import { render, staticRenderFns } from "./SimpleCashier.vue?vue&type=template&id=00f5485d&scoped=true"
import script from "./SimpleCashier.vue?vue&type=script&lang=js"
export * from "./SimpleCashier.vue?vue&type=script&lang=js"
import style0 from "./SimpleCashier.vue?vue&type=style&index=0&id=00f5485d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5485d",
  null
  
)

export default component.exports